import { PageRenderTransition, prependToNonHttpsHrefs } from '@lib/server';
import { RTEContent } from '@types';

import { GraphicCTA } from '../components/graphic-cta';
import { BlockBase, Wrapper, getMarginClassNames } from './utils';

export interface CTAProps extends BlockBase {
  internalLink: boolean;
  buttonLink: string;
  buttonText: string;
  title: string;
  descriptionRTE: RTEContent;

  // these should be destructured from the props so they're not passed to the dom
  transition?: PageRenderTransition;
  /** @deprecated */
  description?: string;
}

export function CTA({
  params,
  internalLink,
  descriptionRTE,
  id,
  margin,

  // these should be destructured from the props so they're not passed to the dom
  transition,
  description,
  ...data
}: CTAProps) {
  if (internalLink && params?.venue) {
    data.buttonLink = `/${params.venuesPage}/${params.venue}${data.buttonLink}`;
  }

  let content;

  if (descriptionRTE) {
    content = params?.venue
      ? prependToNonHttpsHrefs(descriptionRTE?.content, `/${params.venuesPage}/${params.venue}`)
      : descriptionRTE?.content;
  } else {
    content = description;
  }

  return (
    <Wrapper id={id} className={getMarginClassNames(margin)}>
      <GraphicCTA {...data} description={content} />
    </Wrapper>
  );
}
